(function () {
  if (customElements.get('section-tab')) return;

  class SectionTab extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.pebbleTabsBound) return;
      this.pebbleTabsBound = true;

      const root = this;
      const tabs = root.querySelectorAll('[data-tab-handle]');
      if (tabs.length < 2) return;

      const section = root.closest('.section-container');
      const content = section
        ? section.querySelector('.section-content')
        : root.nextElementSibling;
      if (!content) return;

      tabs.forEach((tab) => {
        tab.addEventListener('click', function () {
          const handle = this.getAttribute('data-tab-handle');
          if (!handle) return;

          tabs.forEach((item) => {
            item.classList.remove('active', 'is-active');
            if (item.getAttribute('role') === 'tab') {
              item.setAttribute('aria-selected', 'false');
            }
          });

          this.classList.add('active');
          if (this.getAttribute('role') === 'tab') {
            this.classList.add('is-active');
            this.setAttribute('aria-selected', 'true');
          }

          content
            .querySelectorAll('[data-tab-content].active')
            .forEach((panel) => panel.classList.remove('active'));

          const target = content.querySelector('[data-tab-content="' + handle + '"]');
          if (target) target.classList.add('active');
        });
      });
    }
  }

  customElements.define('section-tab', SectionTab);
})();
